import React from 'react';
import qs from 'qs';
import ErrorView from './ErrorView';
import { useSecureQueryParameters } from 'hooks/useQueryParameters';
import env from 'utils/env';

const Error: React.FC = props => {
  const allowedQueryParameters = useSecureQueryParameters();

  const restartPath = `${env.BASENAME}/prequal/phone-lookup${qs.stringify(
    allowedQueryParameters,
    {
      addQueryPrefix: true,
    },
  )}`;

  return <ErrorView {...props} restartPath={restartPath} />;
};

export default Error;
